import { Routes } from '@angular/router';

import { PromotionDetailsComponent } from './promotion-details.component';
import { PromotionsListComponent } from './promotions-list.component';
import { PromotionDetailsResolver, PromotionsListResolver } from './promotions.resolvers';

export const promotionsRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                component: PromotionsListComponent,
                resolve: {
                    initData: PromotionsListResolver,
                },
            },
            {
                path: ':product',
                component: PromotionsListComponent,
                resolve: {
                    initData: PromotionsListResolver,
                },
            },
            {
                path: ':product/:folderId',
                component: PromotionDetailsComponent,
                resolve: {
                    initData: PromotionDetailsResolver,
                },
            },
            {
                path: ':product/:x1/:x2/:folderId',
                component: PromotionDetailsComponent,
                resolve: {
                    initData: PromotionDetailsResolver,
                },
            },
        ],
    },
];
